import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Layouts
import MainLayout from "layouts/Main";

// Components
import { Button, InputField } from "@octopus-investments/deep-sea-components";

// Actions
import { setContent } from "store/slices/applicationSlice";
import { setResendButtonLoader } from "store/slices/loadersSlice";
import { sendNewEmail } from "store/slices/accountSlice";

// Tracking
import { ampli } from "ampli";

// Styles
import "./TokenExpiredPage.scss";

export default function TokenExpiredPage() {
  const [status, setStatus] = useState("This link has expired");

  const { email } = useSelector(({ application }) => application);
  const { isResendButtonLoader } = useSelector(({ loaders }) => loaders);

  // Redux
  const reduxDispatch = useDispatch();

  function handleResendButton() {
    if (isResendButtonLoader) return;

    reduxDispatch(setResendButtonLoader(true));

    reduxDispatch(sendNewEmail({ returnUrl: false })).then(result => {
      const { success } = result.payload;

      ampli.linkExpiredClicked({
        email,
      });

      if (success) {
        reduxDispatch(setContent("checkMail"));
      } else {
        setStatus("Error. Please try again");
        return reduxDispatch(setResendButtonLoader(false));
      }
    });
  }

  return (
    <MainLayout>
      <div className="token-expire-content">
        <h1 className="coheadline navyBlue">{status}</h1>

        <div className="information-block">
          Your verification link has expired. Click the button below and we’ll send you a new one.
        </div>

        <div className="send-new-link-block">
          <InputField
            className="client-email"
            value={email}
            disabled
            id="tokenExpiredPageEmailInput"
            label="Email address"
            name="email"
          />
          <Button
            customWidth="183px"
            isLoading={isResendButtonLoader}
            label="Send new link"
            onClick={handleResendButton}
            variant="solid"
          />
        </div>
      </div>
    </MainLayout>
  );
}
